import { Divider, Stack, DialogContent, DialogActions, Dialog, Button } from '@mui/material';
import { useForm } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';
import { useDispatch } from 'react-redux';

import { Strings } from '@app/constants';
import { FormProvider, RHFTextField } from '@app/components';
import { Header } from '@app/sections/header';
import { IVendor } from '../types';
import { addVendor } from '../slice';
import { selectAddVendorState } from '../selectors';
import { useRequestState } from '@app/hooks';

interface Props {
  open: boolean;
  onClose: VoidFunction;
  row?: IVendor[];
}

const AddVender = ({ open, onClose, row }: Props) => {
  const methods = useForm<IVendor>({});
  const dispatch = useDispatch();
  const onSubmit = (form: IVendor) => {
    console.log('form', form);
    dispatch(addVendor({ ...form }));
  };
  const { loading } = useRequestState({
    stateSelector: selectAddVendorState,
    onSuccess: onClose,
    successMessageShown: true,
    errorShown: true,
  });

  return (
    <>
      <FormProvider methods={methods}>
        <Dialog open={open} fullWidth>
          <Header variant="dialog" title={Strings.assets.addVender} onClose={onClose} />
          <Divider />
          <DialogContent>
            <Stack spacing={2} my={2}>
              <RHFTextField name="name" label={Strings.field.name} fullWidth variant="outlined" />
            </Stack>
          </DialogContent>
          <Divider />
          <DialogActions>
            <Button variant="outlined" color="inherit" onClick={onClose}>
              {Strings.button.cancel}
            </Button>
            <LoadingButton
              variant="contained"
              type="submit"
              loading={loading}
              onClick={methods.handleSubmit(onSubmit)}
            >
              {Strings.button.save}
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </FormProvider>
    </>
  );
};

export { AddVender };
